export default {
  color: "#f05a28"
};
